/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const HomeHealthCertificationStatus = {
    Present: 'present',
    NotFound: 'not_found',
    NeedsReview: 'needs_review'
} as const;
export type HomeHealthCertificationStatus = typeof HomeHealthCertificationStatus[keyof typeof HomeHealthCertificationStatus];


export function instanceOfHomeHealthCertificationStatus(value: any): boolean {
    for (const key in HomeHealthCertificationStatus) {
        if (Object.prototype.hasOwnProperty.call(HomeHealthCertificationStatus, key)) {
            if (HomeHealthCertificationStatus[key as keyof typeof HomeHealthCertificationStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function HomeHealthCertificationStatusFromJSON(json: any): HomeHealthCertificationStatus {
    return HomeHealthCertificationStatusFromJSONTyped(json, false);
}

export function HomeHealthCertificationStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeHealthCertificationStatus {
    return json as HomeHealthCertificationStatus;
}

export function HomeHealthCertificationStatusToJSON(value?: HomeHealthCertificationStatus | null): any {
    return value as any;
}

export function HomeHealthCertificationStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): HomeHealthCertificationStatus {
    return value as HomeHealthCertificationStatus;
}

